import { render, staticRenderFns } from "./ChangeViewButton.vue?vue&type=template&id=4a7c8521&scoped=true&"
import script from "./ChangeViewButton.vue?vue&type=script&lang=js&"
export * from "./ChangeViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ChangeViewButton.vue?vue&type=style&index=0&id=4a7c8521&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7c8521",
  null
  
)

export default component.exports